<ion-header class="without-border">
    <ion-toolbar class="theme">
        <ion-buttons slot="end">
            <ion-button size="large" (click)="dismissModal()" *ngIf="allowDismiss">
                <ion-icon name="close-circle-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>
            {{'app_lock.title' | translate}}
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="theme">
    <ion-grid>
        <ion-row >
            <ion-col size="12" class="d-flex flex-column align-items-center">
                <ion-img class="logo" src="assets/logo/logo.png"></ion-img>

                <ion-label class="ion-text-wrap ion-text-center m-2" color="light">
                    {{'app_lock.message' | translate}} ({{version}})
                </ion-label>
            </ion-col>

            <ion-col size="12">
                <ion-button class="mt-3" expand="block" color="primary" (click)="goToUpdate()">
                    {{'app_lock.text_button' | translate}}
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>